export const ERROR = 'viewService/ERROR'

export const SAVE_SERVICE = 'viewService/SAVE_SERVICE'
export const SAVE_SERVICE_SUCCESS = 'viewService/SAVE_SERVICE_SUCCESS'
export const SAVE_SERVICE_ERROR = 'viewService/SAVE_SERVICE_ERROR'

export const DELETE_SERVICE_TYPE = 'viewService/DELETE_SERVICE_TYPE'
export const DELETE_SERVICE_TYPE_SUCCESS = 'viewService/DELETE_SERVICE_TYPE_SUCCESS'
export const DELETE_SERVICE_TYPE_ERROR = 'viewService/DELETE_SERVICE_TYPE_ERROR'

export const GET_SERVICE_INFO = 'viewService/GET_SERVICE_INFO'
export const GET_SERVICE_INFO_ERROR = 'viewService/GET_SERVICE_INFO_ERROR'
export const GET_SERVICE_INFO_SUCCESS = 'viewService/GET_SERVICE_INFO_SUCCESS'
export const GET_SERVICE_INFO_AVAILABILITY_SUCCESS = 'viewService/GET_SERVICE_INFO_AVAILABILITY_SUCCESS'
export const GET_SERVICE_INFO_AVAILABILITY_VIEW_MODE_SUCCESS =
  'viewService/GET_SERVICE_INFO_AVAILABILITY_VIEW_MODE_SUCCESS'
export const SET_SERVICE = 'viewService/SET_SERVICE'
export const SET_CURRENT_SERVICE = 'viewService/SET_CURRENT_SERVICE'
export const SET_SERVICE_TYPE_LOADING_STATUS = 'viewService/SET_SERVICE_TYPE_LOADING_STATUS'
export const RESET = 'viewService/RESET'
export const SET_SAVE_SUCCESS = 'viewService/SET_SAVE_SUCCESS'
export const RESET_DATA_FOR_EDIT_PROVIDER = 'viewService/RESET_DATA_FOR_EDIT_PROVIDER'

export const syncViewServiceBlacklist = [SAVE_SERVICE, DELETE_SERVICE_TYPE, GET_SERVICE_INFO]
